import { render } from "./Index.vue?vue&type=template&id=67d2a630&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=67d2a630&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-67d2a630"

export default script